import { apolloProvider } from '@/modules/GraphQL';
import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { GET_PDF, GET_PDF_MSB, GET_TEST_PDF_MSB } from '@/graphql/Mystage/material';
import { SALES_TRIAL_PDF } from '@/graphql/salesTrial';
import { bizmatesApi } from '@/utils/bizmatesApi';
import { mystageServiceIdHeaderName } from '@/utils/constants';
import store from '@/store';
import logger from '@/modules/Logger';

export const GetPdfService = {
  msb: async (lessonId, materialId, isTrial, isLessonTest, isDefaultLayout, jwtKeyValue, callback) => {
    const client = myStageApolloProvider.defaultClient;

    if (isTrial) {
      logger.debug(`[Materials][PDF] Fetching PDF from Sales Trial GraphQL endpoint`, {
        operation: 'materials:get_pdf'
      });

      const { data } = await client.query({
        query: SALES_TRIAL_PDF,
        fetchPolicy: 'no-cache',
        variables: {
          m: parseInt(materialId)
        },
        context: {
          authRequired: false,
          headers: {
            [mystageServiceIdHeaderName]: store.state.triallesson.serviceId
          }
        }
      });

      if (data?.salesTrialPdf) {
        callback(data.salesTrialPdf);
      } else {
        logger.error(`[Materials][PDF] Empty result from Sales Trial PDF GraphQL API`, {
          operation: 'materials:get_pdf',
          event_type: 4,
          lesson_id: lessonId
        });
      }
      return;
    }

    logger.debug(`[Materials][PDF] Fetching PDF from MSB GraphQL endpoint`, {
      operation: 'materials:get_pdf'
    });

    const { data } = await client.query({
      query: isLessonTest ? GET_TEST_PDF_MSB: GET_PDF_MSB,
      fetchPolicy: 'no-cache',
      variables: {
        b: parseInt(lessonId),
        m: parseInt(materialId),
        dl: +isDefaultLayout
      }
    });

    if (data?.getPdf) {
      callback(data.getPdf);
    } else {
      logger.error(`[Materials][PDF] Empty result from MSB PDF GraphQL API`, {
        operation: 'materials:getPdf',
        event_type: 4,
        lesson_id: lessonId
      });
    }
  },
  // Method to fetch PDF from new GraphQL endpoint
  mbti: async (lessonId, materialId, isTrial, isLessonTest, isDefaultLayout, jwtKeyValue, callback) => {
    logger.debug(`[Materials][PDF] Fetching PDF from MBTI GraphQL endpoint`, {
      operation: 'materials:get_pdf'
    });

    const client = apolloProvider.defaultClient;
    const { data } = await client.query({
      query: GET_PDF,
      fetchPolicy: 'no-cache',
      variables: {
        b: parseInt(lessonId),
        m: parseInt(materialId),
        dl: +isDefaultLayout
      }
    });

    if (data?.get_pdf) {
      callback(data.get_pdf);
    } else {
      logger.error(`[Materials][PDF] Empty result from MBTI PDF GraphQL API`, {
        operation: 'materials:get_pdf',
        event_type: 4,
        lesson_id: lessonId
      });
    }
  },

  // Method to fetch PDF from legacy REST API endpoint
  legacy: async (lessonId, materialId, isTrial, isLessonTest, isDefaultLayout, jwtKeyValue, callback) => {
    logger.debug(`[Materials][PDF] Fetching PDF from legacy endpoint`, {
      operation: 'materials:get_pdf'
    });

    let path = isLessonTest ? 'materials/testPdf.json' : 'materials/pdf.json';
    if (isTrial) {
      path = 'sales/pdf';
    }
    const params = {
      b: lessonId,
      m: materialId,
      dl: +isDefaultLayout,
      ...(isTrial && jwtKeyValue),
    };

    await bizmatesApi.get(path, { params }, (response) => {
      if (response.data?.url) {
        callback(response.data);
      } else {
        logger.error(`[Materials][PDF] Empty result from legacy PDF API`, {
          operation: 'materials:get_pdf',
          event_type: 4,
          lesson_id: lessonId
        });
      }
    });
  }
};
